import axiosInstance from "@/setup/setup-api";
import genericAPI from "@/api/api";
import TokenService from "../services/token-service.js";
import type { ZUser } from "@schemas/user.schemas";

interface ILoginRequestBody {
    email: string;
    password: string;
}

interface IRegisterRequestBody {
    organisation?: string;
    email: string;
    password: string;
    name: string;
    type: string;
}

interface IForgotPasswordRequestBody {
    email: string;
}
interface IResetPasswordRequestBody {
    password: string;
    resetPasswordToken: string;
}

interface IChangePasswordRequestBody {
    currentPassword: string;
    newPassword: string;
    newPasswordConfirm: string;
}

interface IRefreshRequestBody {
    email: string;
    refreshToken: string;
}



export default {
    endpointUrl: "auth",
    /**
     * Login user
     * @param payload
     */
    async login(payload: ILoginRequestBody): Promise<any> {
        if (!payload) {
            throw new Error(`data is required`);
        }
        try {
            const responseData = await genericAPI.postDocument<ZUser>(this.endpointUrl + "/login", payload);
            TokenService.setLocalAccessToken(responseData.token)
            TokenService.setLocalRefreshToken(responseData.refreshToken);
            TokenService.setLocalUser(responseData.user)

            //log.trace("login response", response);
            // returns obj instead of array...
            axiosInstance.defaults.headers.common['Authorization'] = responseData.token;
            console.log(" axios.defaults.headers",  axiosInstance.defaults.headers)
            return responseData;
        } catch (error) {
            console.error('Error login:', error);
            throw error; // Rethrow the error for the caller to handle
        }
    },

    /**
     * signUps user and if successful login as well
     * @param payload
     * @returns {Promise<{user: *, token: *}>}
     */
    async register(payload: IRegisterRequestBody): Promise<any> {
        if (!payload) {
            throw new Error(`data is required`);
        }
        try {
            // TODO use axios directly because response is axios.response.data therefore you cannot access headers
            const response = await genericAPI.postDocument<ZUser>(this.endpointUrl + "/register", payload);
            /*
            // we do not set token after registration, because we do not want to login automatically
            // currently user is disabled
            let token = response.headers['x-auth-token'];
            axiosInstance.defaults.headers.common['Authorization'] = token;
            return {
                token,
                user: response.data
            };
            */
            return {
                user: response.data
            };
        } catch (error) {
            console.error('Error register:', error);
            throw error; // Rethrow the error for the caller to handle
        }
    },

    async forgotPassword(payload: IForgotPasswordRequestBody): Promise<any> {
        if (!payload) {
            throw new Error(`data is required`);
        }
        try {
            const responseData = await genericAPI.postDocument<ZUser>(this.endpointUrl + "/forgotpassword", payload);
            // Logger.trace("forgotPassword response", data);
            return responseData;
        } catch (error) {
            console.error('Error forgotPassword:', error);
            throw error; // Rethrow the error for the caller to handle
        }
    },

    async resetPassword(payload: IResetPasswordRequestBody): Promise<any> {
        if (!payload) {
            throw new Error(`data is required`);
        }
        try {
            const responseData = await genericAPI.postDocument<ZUser>(this.endpointUrl + "/resetpassword", payload);
            // Logger.trace("resetPassword response", response);
            return responseData;
        } catch (error) {
            console.error('Error forgotPassword:', error);
            throw error; // Rethrow the error for the caller to handle
        }
    },

    async changePassword(payload: IChangePasswordRequestBody): Promise<any> {
        if (!payload) {
            throw new Error(`data is required`);
        }
        try {
            const responseData = await genericAPI.postDocument<ZUser>(this.endpointUrl + "/changepassword", payload);
            // Logger.trace("resetPassword response", response);
            return responseData;
        } catch (error) {
            console.error('Error changePassword:', error);
            throw error; // Rethrow the error for the caller to handle
        }
    },

    async logout(): Promise<any> {
        try {
            const responseData = await genericAPI.postDocument<ZUser>(this.endpointUrl + "/logout", {});
            //Logger.trace("logout response");
            delete axiosInstance.defaults.headers.common['Authorization']
            TokenService.removeLocalEntries();
            return responseData;
        } catch (error) {
            console.error('Error forgotPassword:', error);
            throw error; // Rethrow the error for the caller to handle
        }
    },

    async refresh(payload: IRefreshRequestBody): Promise<any> {
        if (!payload) {
            throw new Error(`data is required`);
        }
        try {
            const responseData = await genericAPI.postDocument<ZUser>(this.endpointUrl + "/refresh", payload);
            TokenService.setLocalAccessToken(responseData.token)
            //Logger.trace("auth api: refresh", response);
            //TODO improve check with other solution in auth, user api and setup interceptor
            axiosInstance.defaults.headers.common['Authorization'] = responseData.token;
            return responseData;
        } catch (error) {
            console.error('Error forgotPassword:', error);
            throw error; // Rethrow the error for the caller to handle
        }
    }
};
